import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext, useMemo } from 'react';
import { ScreenSize } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/giveaway/GlobalContext';

export default function useSpinnerConfig(containerSize: ScreenSize) {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    isSpinnerReady: { setData: setSpinnerReady },
    setIsSpinnerImmersive,
    setOpenHotspot,
    setOpenKeyFeatures
  } = useContext(GlobalContext);

  const getHelpers = useCallback(
    ({ openHotspot = () => {}, openKeyFeatures = () => {} }) => {
      setOpenHotspot(() => openHotspot);
      setOpenKeyFeatures(() => openKeyFeatures);
    },
    [setOpenHotspot, setOpenKeyFeatures]
  );

  return useMemo(
    () => ({
      autoResizing: true,
      callbacks: { trackEvent },
      eventListener: event => {
        switch (event.type) {
          case 'ui/setSpinnerReady':
          case 'spinner/ui/SET_SPINNER_READY':
            setSpinnerReady(true);
            break;
          case 'ui/setImmersiveMode':
          case 'spinner/ui/SET_IMMERSIVE_MODE':
            setIsSpinnerImmersive(event.payload);
            break;
          default:
        }
      },
      customDims: containerSize ?? null,
      showHeader: false,
      getHelpers
    }),
    [
      containerSize,
      getHelpers,
      setIsSpinnerImmersive,
      setSpinnerReady,
      trackEvent
    ]
  );
}
